// Tenant Detection and Configuration Module
// Handles multi-tenant support for EU and Indian regions

// Tenant configuration
const TENANT_CONFIG = {
    eu: {
        id: 'eu',
        name: 'EU',
        domains: ['app.cyberschooling.eu', 'localhost'],
        curriculumScope: {
            tenant: 'eu',
            continent: 'Europe'
        },
        defaultLanguage: 'en',
        languages: ['ar', 'bg', 'cs', 'da', 'de', 'el', 'en', 'es', 'fi', 'fr', 'hr', 'hu', 'it', 'nl', 'no', 'pl', 'pt', 'ro', 'ru', 'sk', 'sv', 'tr', 'uk'],
        theme: {
            accentColor: '#00FF66' // Green
        }
    },
    africa: {
        id: 'africa',
        name: 'Africa',
        domains: ['app.cyberschooling.africa'],
        curriculumScope: {
            tenant: 'africa',
            continent: 'Africa'
        },
        defaultLanguage: 'en',
        languages: ['af', 'am', 'ar', 'en', 'ff', 'fr', 'ha', 'ig', 'mg', 'pt', 'rw', 'so', 'sw', 'ti', 'wo', 'xh', 'yo', 'zu'],
        theme: {
            accentColor: '#FFD700' // Gold/Yellow for Africa
        }
    },
    asia: {
        id: 'asia',
        name: 'Asia',
        domains: ['app.cyberschooling.asia'],
        curriculumScope: {
            tenant: 'asia',
            continent: 'Asia'
        },
        defaultLanguage: 'en',
        languages: ['en', 'fa', 'fil', 'he', 'id', 'ja', 'ka', 'kk', 'km', 'ko', 'lo', 'mn', 'ms', 'my', 'ps', 'th', 'uz', 'vi', 'zh'],
        theme: {
            accentColor: '#FF4500' // Orange-red for Asia
        }
    },
    india: {
        id: 'india',
        name: 'India',
        domains: ['app.cyberschooling.in'],
        curriculumScope: {
            tenant: 'india',
            continent: 'Asia',
            countryCode: 'IN'
        },
        defaultLanguage: 'en',
        languages: ['as', 'bn', 'brx', 'doi', 'en', 'gu', 'hi', 'kn', 'kok', 'ks', 'mai', 'ml', 'mni', 'mr', 'ne', 'or', 'pa', 'sa', 'sd', 'ta', 'te', 'ur'],
        theme: {
            accentColor: '#FF6B35' // Saffron-orange
        }
    },
    lat: {
        id: 'lat',
        name: 'Latin America',
        domains: ['app.cyberschooling.lat'],
        curriculumScope: {
            tenant: 'lat',
            region: 'Latin America'
        },
        defaultLanguage: 'es',
        languages: ['ay', 'en', 'es', 'gn', 'ht', 'nah', 'pt-BR', 'qu'],
        theme: {
            accentColor: '#00BFFF' // Sky blue for Latin America
        }
    }
};

// Singleton instance
let currentTenant = null;

/**
 * Detect the current tenant based on window.location.hostname
 * @returns {Object} Tenant configuration object
 */
export function detectTenant() {
    const hostname = window.location.hostname;

    // Check all configured tenants
    for (const tenantId in TENANT_CONFIG) {
        if (TENANT_CONFIG[tenantId].domains.includes(hostname)) {
            return TENANT_CONFIG[tenantId];
        }
    }

    // Default to EU if no match (e.g., for development on non-standard domains)
    console.warn(`Unknown hostname: ${hostname}. Defaulting to EU tenant.`);
    return TENANT_CONFIG.eu;
}

/**
 * Get the current tenant configuration (cached singleton)
 * @returns {Object} Current tenant configuration
 */
export function getCurrentTenant() {
    if (!currentTenant) {
        currentTenant = detectTenant();
        console.log('Tenant detected:', currentTenant.name, `(${currentTenant.id})`);
    }
    return currentTenant;
}

/**
 * Initialize tenant module (called from main.js)
 * @returns {Object} Current tenant
 */
export function initTenant() {
    const tenant = getCurrentTenant();
    return tenant;
}
